import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaDog, FaBaby, FaTrophy, FaImages } from 'react-icons/fa';
import { supabase } from '../lib/supabaseClient';

const cards = [
  { key: 'dogs', label: 'Psy', icon: FaDog, to: '/admin/dogs', table: 'dogs' },
  { key: 'litters', label: 'Mioty', icon: FaBaby, to: '/admin/litters', table: 'litters' },
  { key: 'shows', label: 'Wystawy', icon: FaTrophy, to: '/admin/shows', table: 'shows' },
  { key: 'gallery', label: 'Zdjęcia w galerii', icon: FaImages, to: '/admin/gallery', table: 'gallery' },
];

const DashboardPage = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    (async () => {
      const result = {};
      for (const c of cards) {
        const { count } = await supabase.from(c.table).select('*', { count: 'exact', head: true });
        result[c.key] = count ?? 0;
      }
      setCounts(result);
    })();
  }, []);

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.key} to={c.to} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">{c.label}</p>
                  <p className="text-3xl font-bold text-gray-800 mt-1">{counts[c.key] ?? '—'}</p>
                </div>
                <div className="w-12 h-12 rounded-lg bg-brand-accent/10 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-brand-accent" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-8 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Witaj w panelu Etsuko CMS</h3>
        <p className="text-gray-600 text-sm">
          Zarządzaj psami, miotami, wystawami i galerią. Zmiany zapisują się w bazie i są widoczne
          na stronie natychmiast — bez ponownego wdrażania.
        </p>
      </div>
    </div>
  );
};

export default DashboardPage;
